<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:body>
            <b-row>
                <b-col lg="12" sm="12">
                    <b-table-simple bordered>
                        <b-tr>
                            <b-th style="width:20%">{{ $t('externalUser.registration_id') }}</b-th>
                            <b-td style="width:30%">{{ $n(formData.registration_id, { useGrouping: false }) }}</b-td>
                            <b-th style="width:20%">{{ $t('awareness_config.year') }}</b-th>
                            <b-td style="width:30%">{{ $n(formData.year, { useGrouping: false }) }}</b-td>
                        </b-tr>
                        <b-tr>
                            <b-th style="width:20%">{{ $t('awareness_config.event_type') }}</b-th>
                            <b-td style="width:30%">{{ ($i18n.locale=='bn') ? formData.event_type_name_bn : formData.event_type_name }}</b-td>
                            <b-th style="width:20%">{{ $t('awareness_config.event_name') }}</b-th>
                            <b-td style="width:30%">{{ ($i18n.locale=='bn') ? formData.event_name_bn : formData.event_name }}</b-td>
                        </b-tr>
                        <b-tr>
                            <b-th style="width:20%">{{ $t('event_manage.from_date') }}</b-th>
                            <b-td style="width:30%">{{ formData.form_date | dateFormat}}</b-td>
                            <b-th style="width:20%">{{ $t('event_manage.to_date') }}</b-th>
                            <b-td style="width:30%">{{ formData.to_date | dateFormat }}</b-td>
                        </b-tr>
                        <b-tr>
                            <b-th style="width:20%">{{ $t('awareness_config.stall_type') }}</b-th>
                            <b-td style="width:30%">{{ ($i18n.locale=='bn') ? formData.stall_type_name_bn : formData.stall_type_name }}</b-td>
                            <b-th style="width:20%">{{ $t('externalUser.rent_per_stall') }}</b-th>
                            <b-td style="width:30%">{{ $n(formData.rent_per_stall) }}</b-td>
                        </b-tr>
                        <b-tr>
                            <b-th style="width:20%">{{ $t('externalUser.number_of_stall') }}</b-th>
                            <b-td style="width:30%">{{ $n(formData.number_of_stall) }}</b-td>
                            <b-th style="width:20%">{{ $t('externalUser.total_rent') }}</b-th>
                            <b-td style="width:30%">{{ $n(formData.total_cost) }}</b-td>
                        </b-tr>
                        <b-tr>
                            <b-th style="width:20%">{{ $t('event_manage.payment_type') }}</b-th>
                            <b-td style="width:30%">{{ ($i18n.locale=='bn') ? formData.payment_type_bn : formData.payment_type }}</b-td>
                            <b-th style="width:20%" v-if="formData.voucher_no">{{ $t('event_manage.voucher_no') }}</b-th>
                            <b-td style="width:30%" v-if="formData.voucher_no">{{ (formData.voucher_no) }}</b-td>
                        </b-tr>
                        <b-tr>
                            <b-th style="width:20%">{{ $t('externalUser.org_name') }}</b-th>
                            <b-td style="width:30%">{{ ($i18n.locale=='bn') ? formData.org_name_bn : formData.org_name }}</b-td>
                        </b-tr>
                        <!-- <b-tr>
                            <b-th style="width:20%" v-if="formData.attachment">{{ $t('info_manage.attachment') }}</b-th>
                            <b-td style="width:30%" v-if="formData.attachment"><a target = '_blank' v-if="this.formData.attachment" :href="url + 'download-attachment?file=' + '/uploads/direact-assign-stall/payment/attachment/'" style="margin: auto;" download><i class="ri-download-cloud-fill" style="font-size:67px"></i>  {{this.formData.attachment}}</a></b-td>
                        </b-tr> -->
                    </b-table-simple>
                    <b-overlay v-if="formData.stall_assign_details.length > 0">
                      <template>
                        <div style="font-size:14px; background-color: #66CC99; padding:6px" class="mt-4">
                            <h5 class="text-white text-center"> {{ $t('awareness_config.stall_info') }}</h5>
                        </div>
                      </template>
                      <b-table-simple bordered>
                          <b-tr>
                              <th class="text-center mytd" width="100px">{{ $t('globalTrans.sl_no') }}</th>
                              <b-th>{{ $t('awareness_config.stall_name') }}</b-th>
                          </b-tr>
                            <b-tr v-for="(info, index) in formData.stall_assign_details" :key="index" class="mt-3">
                                <b-td class="text-center mytd">{{ $n(index + 1) }}</b-td>
                                <b-td>{{ ($i18n.locale=='bn') ? $store.state.AwarenessEventService.commonObj.stallList.find(item => item.value === parseInt(info.stall_detail_id)).text_bn : $store.state.AwarenessEventService.commonObj.stallList.find(item => item.value === parseInt(info.stall_detail_id)).text_en }}</b-td>
                            </b-tr>
                      </b-table-simple>
                    </b-overlay>
                </b-col>
              </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import { awarenessEventServiceBaseUrl } from '@/config/api_config'

export default {
  props: ['item'],
  components: {
  },
  data () {
    return {
      formData: [],
      awarenessEventServiceBaseUrl: awarenessEventServiceBaseUrl
    }
  },
  created () {
    if (this.item) {
       this.formData = this.item
    }
  },
  mounted () {
    core.index()
  },
  computed: {
    currentLocale () {
      return this.$i18n.locale
    }
  },
  watch: {
  },
  methods: {
  }
}
</script>
<style lang="scss">
    .details {
    h5 {
      color: green !important;
      font-size: 20px !important;
    }
    .table-bordered td:nth-child(2n+1) {
      font-weight: 700;
    }
  }
  .hidden_header {
    display: none
  }
  [dir=ltr][mode=light] .card-body {
    flex: 1 1 auto;
    min-height: 1px;
    padding: 10px;
  }
  .mytd{
        padding: 0.45rem 0.75rem 0.45rem 0.75rem !important;
    }
</style>
